export const TAGLINE =
  "Traverse six credential realms, restore the sacred Mainline, and become a legend of the Agentic World.";

export const INTRO_NARRATION = [
  "Welcome to the Agentic World, where every repository once flowed safely through the sacred Mainline.",
  "A sprawling corruption now fractures teams into unstable branches and failed releases. The realm needs an engineer who can master each discipline and restore order.",
  "Earn six credentials in sequence — GH-100, GH-900, GH-500, GH-300, GH-200, and GH-600 — then face the final corruption at Mainline Core.",
];

export const VICTORY_NARRATION = [
  "You completed every credential trial and rebuilt confidence across the Agentic World.",
  "The Mainline is stable again. New legends will follow the path you forged.",
];

export const MENTOR_DIALOG = {
  gh100: [
    "Guide of Governance: Begin with GH-100 — GitHub Administration.",
    "Take the Fork of Curiosity and enforce structure before chaos can branch again.",
  ],
  gh900: [
    "Guide of Core Skills: GH-900 is your foundation for repositories, collaboration, and flow.",
    "Take the Bubbles of Clarity. Keep fundamentals crystal clear under pressure.",
  ],
  gh500: [
    "Security Sentinel: GH-500 proves you can defend the codebase at every stage.",
    "Wear the Goggles of Insight and expose hidden threats before they spread.",
  ],
  gh300: [
    "Copilot Sage: GH-300 teaches you to collaborate with AI as a force multiplier.",
    "Refine your Fork of Curiosity — better prompts, better outcomes.",
  ],
  gh200: [
    "Automation Architect: GH-200 turns repeatable work into resilient workflow runs.",
    "Carry the Bubbles of Clarity so every pipeline step is understandable and observable.",
  ],
  gh600: [
    "Agentic Master: GH-600 crowns your path through agentic AI development.",
    "Your Goggles of Insight are now calibrated for complex, multi-agent systems.",
  ],
};

export const LEVEL_INTROS = {
  gh100: "Administration Citadel — where governance keeps every team aligned.",
  gh900: "Foundations Grove — where core GitHub skills are forged.",
  gh500: "Security Bastion — where vulnerabilities are hunted before release.",
  gh300: "Copilot Spires — where AI pair programming reaches full flow.",
  gh200: "Actions Foundry — where automation pipelines temper delivery speed.",
  gh600: "Agentic Summit — where intelligent systems collaborate to ship safely.",
  boss: "Mainline Core — where final corruption waits to be purged.",
};
